
(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    function MatrixListItemViewModel(options) {

        var defaults = {
            PrimaryID: 0,
            PrimaryText: '',
            LevelIDs: '',
            CampusIDs: '',
            DeliveryMethodIDs: '',
            AdmissionsProgramOfferingItemIDs: '',
            GoalIDs: '',
            ProgramIDs: '',
            IsPeriodBased: false,
            LevelOfStudyIDs: '',
            IsDefault: false,
            Sequence: ""
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.PrimaryID = ko.observable(settings.PrimaryID);
        this.PrimaryText = ko.observable(settings.PrimaryText);
        this.LevelIDs = ko.observable(settings.LevelIDs);
        this.CampusIDs = ko.observable(settings.CampusIDs);
        this.DeliveryMethodIDs = ko.observable(settings.DeliveryMethodIDs);
        this.AdmissionsProgramOfferingItemIDs = ko.observable(settings.AdmissionsProgramOfferingItemIDs); 
        this.GoalIDs = ko.observable(settings.GoalIDs);
        this.ProgramIDs = ko.observable(settings.ProgramIDs);
        this.IsPeriodBased = ko.observable(settings.IsPeriodBased);
        this.LevelOfStudyIDs = ko.observable(settings.LevelOfStudyIDs);
        this.IsDefault = ko.observable(settings.IsDefault);
        this.Sequence = ko.observable(settings.Sequence);

        this.IsCampusMatch = function (campusID) {
            if (sm.portal.utility.isNullOrEmpty(campusID)) {
                return true;
            }

            var matchKey = '|' + campusID + '|';
            return this.CampusIDs().indexOf(matchKey) >= 0;
        };
        this.IsProgramMatch = function (programID) {
            if (sm.portal.utility.isNullOrEmpty(programID)) {
                return true;
            }

            var matchKey = '|' + programID + '|';
            return this.ProgramIDs().indexOf(matchKey) >= 0;
        };
        this.IsLevelMatch = function (levelID) {
            if (sm.portal.utility.isNullOrEmpty(levelID)) {
                return true;
            }

            var matchKey = '|' + levelID + '|';
            return this.LevelIDs().indexOf(matchKey) >= 0;
        }
        this.IsDeliveryMatch = function (deliveryMethodID) {
            if (sm.portal.utility.isNullOrEmpty(deliveryMethodID)) {
                return true;
            }

            var matchKey = '|' + deliveryMethodID + '|';
            return this.DeliveryMethodIDs().indexOf(matchKey) >= 0;
        }
        this.IsAdmissionsProgramOfferingItemMatch = function (admissionsProgramOfferingItemID) {
            if (sm.portal.utility.isNullOrEmpty(admissionsProgramOfferingItemID)) {
                return true;
            }

            var matchKey = '|' + admissionsProgramOfferingItemID + '|';
            return this.AdmissionsProgramOfferingItemIDs().indexOf(matchKey) >= 0;
        }
        this.IsLevelOfStudyMatch = function (levelOfStudyID) {
            if (sm.portal.utility.isNullOrEmpty(levelOfStudyID)) {
                return true;
            }

            var matchKey = '|' + levelOfStudyID + '|';
            return this.LevelOfStudyIDs().indexOf(matchKey) >= 0;
        }

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        MatrixListItemViewModel: MatrixListItemViewModel,
    });

})(jQuery);